import { SET_PHOTO_DATA } from "../constants/constants";
import { CHILLI_MONTHLY_PHOTO_STEP1_HEADER, CHILLI_MONTHLY_PHOTO_STEP1_DESCRIPTION, CHILLI_MONTHLY_PHOTO_STEP2_HEADER, CHILLI_MONTHLY_PHOTO_STEP2_DESCRIPTION,CHILLI_MONTHLY_RIGHT_ARROW} from "../constants/copy";


const initialState = {
    photoData: "",
    selfInspectPhotoData:"",
    photoAccepted: false,
    photoSubmitted: false,
    mileageReadingDisplayStyle: "none",
    totalMileage: "",

    dashboardPhotoData: "",
    dashboardHeader: CHILLI_MONTHLY_PHOTO_STEP1_HEADER,
    dashboardDescription: CHILLI_MONTHLY_PHOTO_STEP1_DESCRIPTION,
    dashboardDisplayStyle: "block",
    dashboardSubmitBtnDisplayStyle: "inline",
    dashboardNextBtnDisplayStyle: "none",
    dashboardCanSubmit: false,
    dashboardLat: "",
    dashboardLon: "",

    mileagePhotoData: "",
    mileageHeader: CHILLI_MONTHLY_PHOTO_STEP2_HEADER,
    mileageDescription: CHILLI_MONTHLY_PHOTO_STEP2_DESCRIPTION,
    mileageDisplayStyle: "none",
    mileageSubmitBtnDisplayStyle: "inline",
    mileageNextBtnDisplayStyle: "none",
    mileageCanSubmit: false,
    step1RightImageUrl: CHILLI_MONTHLY_RIGHT_ARROW,
    step2RightImageUrl: CHILLI_MONTHLY_RIGHT_ARROW,
    step3RightImageUrl: CHILLI_MONTHLY_RIGHT_ARROW,
    step1Backround: "#e6e6e6",
    step2Backround: "#fff",
    step3Backround: "#fff",
    canSubmitMonthlyMileage: false,
    mileageLat: 0,
    mileageLon: 0,
    selfInspectLat: 0,
    selfInspectLon: 0,
}

const cameraReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_PHOTO_DATA:
            return {
                ...state,
                photoData: ('photoData' in action.payload) ? action.payload.photoData : state.photoData,
                selfInspectPhotoData: ('selfInspectPhotoData' in action.payload) ? action.payload.selfInspectPhotoData : state.selfInspectPhotoData,
                photoAccepted: ('photoAccepted' in action.payload) ? action.payload.photoAccepted : state.photoAccepted,
                photoSubmitted: ('photoSubmitted' in action.payload) ? action.payload.photoSubmitted : state.photoSubmitted,
                mileageReadingDisplayStyle: ('mileageReadingDisplayStyle' in action.payload) ? action.payload.mileageReadingDisplayStyle : state.mileageReadingDisplayStyle,
                totalMileage: ('totalMileage' in action.payload) ? action.payload.totalMileage : state.totalMileage,
                dashboardPhotoData: ('dashboardPhotoData' in action.payload) ? action.payload.dashboardPhotoData : state.dashboardPhotoData,
                dashboardHeader: ('dashboardHeader' in action.payload) ? action.payload.dashboardHeader : state.dashboardHeader,
                dashboardDescription: ('dashboardDescription' in action.payload) ? action.payload.dashboardDescription : state.dashboardDescription,
                dashboardDisplayStyle: ('dashboardDisplayStyle' in action.payload) ? action.payload.dashboardDisplayStyle : state.dashboardDisplayStyle,
                dashboardSubmitBtnDisplayStyle: ('dashboardSubmitBtnDisplayStyle' in action.payload) ? action.payload.dashboardSubmitBtnDisplayStyle : state.dashboardSubmitBtnDisplayStyle,
                dashboardNextBtnDisplayStyle: ('dashboardNextBtnDisplayStyle' in action.payload) ? action.payload.dashboardNextBtnDisplayStyle : state.dashboardNextBtnDisplayStyle,
                dashboardCanSubmit: ('dashboardCanSubmit' in action.payload) ? action.payload.dashboardCanSubmit : state.dashboardCanSubmit,
                mileagePhotoData: ('mileagePhotoData' in action.payload) ? action.payload.mileagePhotoData : state.mileagePhotoData,
                mileageHeader: ('mileageHeader' in action.payload) ? action.payload.mileageHeader : state.mileageHeader,
                mileageDescription: ('mileageDescription' in action.payload) ? action.payload.mileageDescription : state.mileageDescription,
                mileageDisplayStyle: ('mileageDisplayStyle' in action.payload) ? action.payload.mileageDisplayStyle : state.mileageDisplayStyle,
                mileageSubmitBtnDisplayStyle: ('mileageSubmitBtnDisplayStyle' in action.payload) ? action.payload.mileageSubmitBtnDisplayStyle : state.mileageSubmitBtnDisplayStyle,
                mileageNextBtnDisplayStyle: ('mileageNextBtnDisplayStyle' in action.payload) ? action.payload.mileageNextBtnDisplayStyle : state.mileageNextBtnDisplayStyle,
                mileageCanSubmit: ('mileageCanSubmit' in action.payload) ? action.payload.mileageCanSubmit : state.mileageCanSubmit,
                step1RightImageUrl: ('step1RightImageUrl' in action.payload) ? action.payload.step1RightImageUrl : state.step1RightImageUrl,
                step2RightImageUrl: ('step2RightImageUrl' in action.payload) ? action.payload.step2RightImageUrl : state.step2RightImageUrl,
                step3RightImageUrl: ('step3RightImageUrl' in action.payload) ? action.payload.step3RightImageUrl : state.step3RightImageUrl,
                step1Backround: ('step1Backround' in action.payload) ? action.payload.step1Backround : state.step1Backround,
                step2Backround: ('step2Backround' in action.payload) ? action.payload.step2Backround : state.step2Backround,
                step3Backround: ('step3Backround' in action.payload) ? action.payload.step3Backround : state.step3Backround,
                canSubmitMonthlyMileage: ('canSubmitMonthlyMileage' in action.payload) ? action.payload.canSubmitMonthlyMileage : state.canSubmitMonthlyMileage,
                dashboardLat: ('dashboardLat' in action.payload) ? action.payload.dashboardLat : state.dashboardLat,
                dashboardLon: ('dashboardLon' in action.payload) ? action.payload.dashboardLon : state.dashboardLon,
                mileageLat: ('mileageLat' in action.payload) ? action.payload.mileageLat : state.mileageLat,
                mileageLon: ('mileageLon' in action.payload) ? action.payload.mileageLon : state.mileageLon,
                
            }
        default:
            return state
    }
}

export default cameraReducer;